import React, { useState, useEffect } from "react";
import i18n from "../../i18n";
import {
  Dropdown,
  Search,
  Modal,
  MultiSelect,
  Breadcrumb,
  BreadcrumbItem,
} from "carbon-components-react";
import { headerData, invoiceHeaderData } from "./data/billingReportData";
import DashboardTable from "components/Dashboards/DashboardTable";
import * as Constants from "../../requests/URLConstants";
import callPostApi from "../../requests/PostRequests";
import moment from "moment";
import TableToolbarDownload from "../../common/TableToolbarDownload";
import * as DashboardConstants from '../Dashboards/DashboardConstants';
require("./_billingreport.scss");

const NOV_FIXED_DATE = "2022-10-01";

const BillingReport = (props) => {
  const [billingReportData, setBillingReportData] = useState([]);
  const [pdfView, setPdfView] = useState(false);
  const [SearchedBillingReportTableData, setSearchedBillingReportTableData] =
    useState([]);
  const [selectMonths, setSelectMonths] = useState([]);
  const [clientsByUserAccess, setClientsByUserAccess] = useState([]);
  const [searchedValue, setSearchedValue] = useState("");
  const [selectMonth, setselectMonth] = useState([]);
  const [billingReportLoading, setBillingReportLoading] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);

  useEffect(() => {
    getBillingReportData();
    getClientsByUserAccess();
    getMonthDetails();
  }, []);

  function getClientsByUserAccess() {
    callPostApi(Constants.GETUNIQUECLIENTS, {
      "Content-Type": "application/json",
    })
      .then((resp) => {
        let clients = resp.map((client) => client);
        setClientsByUserAccess(clients);
      })
      .catch((error) => {});
  }

  function getCurrentDateInfo() {
    let month = moment(new Date());
    let displayedCurrentDate = {
      value: month.format("MMMM YYYY"),
      month: month.format("MM"),
      year: month.format("YYYY"),
      end: month.endOf("month").format("DD"),
    };
    return displayedCurrentDate;
  }

  function prepareBillingReportData(rowData, monthData) {
    let tableData = [];
    tableData = rowData.map((data, index) => {
      return {
        id: String(index),
        client_name: data.client || "",
        billing_period:
          `01/${monthData.month}/${monthData.year} - ${monthData.end}/${monthData.month}/${monthData.year}` ||
          "",
        billing_month: monthData.value || "",
        date_od_issue: `01/${monthData.month}/${monthData.year}` || "",
        alerts: data.alertcount || "",
        invoice_amount: `US $ ${data.amount}` || "",
        final_amount: data.amount,
        project_id: data.projectid,
        account_id: data.accountid,
        adjustment_for_last_month: String(data.adjustedamount),
        cnum_id: data.cnumid,
        alert_volume_last_month: data.previousalertcount,
        remarks: `Invoice for ${monthData.value}`,
      };
    });
    return tableData;
  }

  const handleClientSelectionChange = (event) => {
    let selectedClient = [];
    selectedClient = event.selectedItems.map((e) => e.key);
    setSelectedClients(selectedClient);
    getBillingReportData(selectMonth, selectedClient);
  };

  const handleChangeMonth = (e) => {
    setselectMonth(e.selectedItem);
    getBillingReportData(e.selectedItem, selectedClients);
  };

  const getMonthDetails = () => {
    let startDate = moment(NOV_FIXED_DATE);
    let endDate = moment(new Date());
    let dates = [];
    endDate.subtract(1, "month"); //Substract one month to exclude endDate itself
    let month = moment(startDate); //clone the startDate
    dates.push({
      value: month.format("MMMM YYYY"),
      month: month.format("MM"),
      year: month.format("YYYY"),
      end: month.endOf("month").format("DD"),
    });
    while (month <= endDate) {
      month.add(1, "month");
      dates.push({
        value: month.format("MMMM YYYY"),
        month: month.format("MM"),
        year: month.format("YYYY"),
        end: month.endOf("month").format("DD"),
      });
    }
    dates.push(getCurrentDateInfo());
    setSelectMonths(dates);
    setselectMonth(getCurrentDateInfo());
  };

  function getBillingReportData(dateValue = {}, selectedOption = []) {
    setBillingReportLoading(true);
    let monthValue;
    if (!selectMonth.value) {
      monthValue = getCurrentDateInfo();
      setselectMonth(monthValue);
    } else {
      monthValue = dateValue;
      setselectMonth(dateValue);
    }
    let formattedData = [];
    let bodyJSON = {
      year: dateValue.year || monthValue.year,
      month: dateValue.month || monthValue.month,
      party_name: selectedOption,
    };

    callPostApi(
      Constants.GETINVOICEDETAILS,
      {
        "Content-Type": "application/json",
      },
      bodyJSON
    )
      .then((resp) => {
        setBillingReportLoading(false);
        formattedData = prepareBillingReportData(resp, monthValue);
        setBillingReportData(formattedData);
      })
      .catch((error) => {
        setBillingReportLoading(false);
      });
  }

  const searchTable = (event) => {
    let searchString = event && event.toUpperCase();
    let searchResult = [];
    let newList = [];
    let string, pattern;
    let matchedStrings;
    if (searchString) {
      newList = billingReportData.filter((element) => {
        for (var property in element) {
          if (element.hasOwnProperty(property)) {
            if (element[property] && property !== "id") {
              string = element[property];
            } else string = "";
            string = string ? string.toString() : "";
            pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
            matchedStrings = string.match(pattern);
            if (matchedStrings && matchedStrings.length) {
              searchResult = searchResult.concat([element]);
              return searchResult;
            }
          }
        }
      });
      setSearchedBillingReportTableData(newList);
    } else {
      setSearchedBillingReportTableData([]);
    }
  };

  return (
    <div className="billing-report">
      <Breadcrumb aria-label="Page navigation">
        <BreadcrumbItem href="/homepage">
          {DashboardConstants.Home}
        </BreadcrumbItem>
      </Breadcrumb>
      <div className="title">{DashboardConstants.billingTitle}</div>
      <div className="title-desc">{DashboardConstants.BillingDescription}</div>
      <ul className="billing-report-section">
        <li className="billing-dropdown">
          <MultiSelect.Filterable
            light
            id="select"
            titleText={DashboardConstants.Client}
            helperText=""
            disabled={false}
            items={clientsByUserAccess}
            itemToString={(item) => (item ? item.key : "")}
            placeholder={DashboardConstants.AllClients}
            onChange={handleClientSelectionChange}
          />
        </li>
        <li className="billing-dropdown">
          <Dropdown
            light
            id="billingReport"
            titleText={DashboardConstants.Months}
            label={DashboardConstants.ChooseOption}
            items={selectMonths}
            itemToString={(item) => (item ? item.value : null)}
            onChange={handleChangeMonth}
            selectedItem={selectMonth}
          />
        </li>

        <li className="search-bar">
          <Search
            onChange={(e) => {
              setSearchedValue(e.target.value || "");
              searchTable(e.target.value);
            }}
            light
            size="lg"
            placeHolderText={DashboardConstants.whatAreYouLookingForToday}
            id="search-1"
          />
        </li>
        <div className="download-btn">
          <TableToolbarDownload
            iconDescription={DashboardConstants.Export} 
            rows={billingReportData}
            headers={invoiceHeaderData}
            title={DashboardConstants.MonthlyBillingReport}
            filename={`${selectMonth && selectMonth.value} ${DashboardConstants.BillingReport}`}
            label={DashboardConstants.Download}
          />
        </div>
      </ul>

      <div className="table-container">
        <DashboardTable
          rows={
            searchedValue.length
              ? SearchedBillingReportTableData
              : billingReportData
          }
          loading={billingReportLoading}
          headers={headerData}
          showPagination={true}
        />
      </div>
    </div>
  );
};

export default BillingReport;
